import { css } from '@emotion/react';
import React, { memo } from 'react';
import { CashRegistryDetails, Section } from '../../../resources/modelTypes';
import CashRegistry from '../../../registries/dashboard/CashRegistry';

export type DisplayCashRegistrySectionProps = {
  section: Section,
};

const styles = {
  wrapper: css`
    display: flex;
    justify-content: center;
    width: 100%;
  `,
};

const getCashRegistrySlug = (cashRegistryUrl: string) => {
  // Returns the cash registry slug by splitting the URL
  // Prod Example: minted.sendbirdie.com/r/asdf -> asdf
  // QA Example: minted-dev.sendbirdie.com/r/asdf -> asdf
  const parts: string[] = cashRegistryUrl.split('/r/');

  if (parts.length > 1) {
    return parts[1];
  }

  return null;
};

const DisplayCashRegistrySection = ({
  section,
}: DisplayCashRegistrySectionProps) => {
  const details = section.sectionDetails as CashRegistryDetails;

  if (!details.websiteUrl) {
    return null;
  }

  const cashRegistrySlug: string | null = getCashRegistrySlug(details.websiteUrl);

  return (
    <div css={styles.wrapper}>
      <CashRegistry
        registryId={details.cashRegistryId}
        registrySlug={cashRegistrySlug}
      />
    </div>
  );
};

const MemoizedDisplayCashRegistrySection = memo(DisplayCashRegistrySection);

export { MemoizedDisplayCashRegistrySection as DisplayCashRegistrySection };
